import Client from '../client'
import type {
  ErrorAble,
  AuthCredentials,
  UserResponse,
  ForgotCredentials,
} from '@/api'

export default class User {
  constructor(private client: Client) {}

  login(data: AuthCredentials): Promise<ErrorAble<UserResponse>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.post('auth/login', { data }))
      } catch (error) {
        reject(error)
      }
    })
  }

  forgot(data: ForgotCredentials): Promise<ErrorAble<unknown>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.post('auth/forgot', { data }))
      } catch (error) {
        reject(error)
      }
    })
  }

  logout(): Promise<unknown> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.post('auth/logout'))
      } catch (error) {
        reject(error)
      }
    })
  }

  refreshToken(): Promise<unknown> {
    return new Promise(async (resolve) => {
      const root = Client.options.base

      resolve(
        await fetch(`${root}/sanctum/csrf-cookie`, {
          mode: 'cors',
          credentials: 'include',
          referrerPolicy: 'no-referrer',
        }),
      )
    })
  }

  stopImpersonating(): Promise<unknown> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await this.client.post(`user/impersonate/stop`))
      } catch (error) {
        reject(error)
      }
    })
  }
}
